import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-sm-12" }
const _hoisted_4 = { class: "card" }
const _hoisted_5 = { class: "card-header pb-0" }
const _hoisted_6 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_7 = { class: "d-flex gap-2" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = { class: "card-body" }
const _hoisted_10 = { class: "row mb-4 justify-content-between" }
const _hoisted_11 = { class: "col-md-3" }
const _hoisted_12 = { class: "input-group" }
const _hoisted_13 = { class: "col-md-5" }
const _hoisted_14 = { class: "d-flex gap-2" }
const _hoisted_15 = {
  key: 0,
  class: "text-center py-5"
}
const _hoisted_16 = {
  key: 1,
  class: "table-responsive table_style"
}
const _hoisted_17 = { class: "table table-striped table-hover align-middle" }
const _hoisted_18 = { class: "table-group-divider" }
const _hoisted_19 = { class: "text-center" }
const _hoisted_20 = { class: "badge bg-secondary" }
const _hoisted_21 = {
  key: 0,
  class: "text-muted small"
}
const _hoisted_22 = { class: "badge bg-info" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { key: 2 }
const _hoisted_26 = { class: "text-center" }
const _hoisted_27 = {
  key: 0,
  class: "badge bg-warning text-dark"
}
const _hoisted_28 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_29 = { class: "text-muted small" }
const _hoisted_30 = { class: "d-flex gap-1" }
const _hoisted_31 = ["onClick", "disabled"]
const _hoisted_32 = ["onClick", "disabled"]
const _hoisted_33 = { class: "dropdown" }
const _hoisted_34 = ["id", "disabled"]
const _hoisted_35 = ["aria-labelledby"]
const _hoisted_36 = { key: 0 }
const _hoisted_37 = ["onClick"]
const _hoisted_38 = { key: 1 }
const _hoisted_39 = ["onClick"]
const _hoisted_40 = { key: 2 }
const _hoisted_41 = ["onClick"]
const _hoisted_42 = {
  key: 2,
  class: "text-center py-5"
}
const _hoisted_43 = {
  key: 3,
  class: "d-flex justify-content-between align-items-center mt-4"
}
const _hoisted_44 = { class: "text-muted" }
const _hoisted_45 = { "aria-label": "Subscriptions pagination" }
const _hoisted_46 = { class: "pagination mb-0" }
const _hoisted_47 = ["onClick"]

import { ref, computed, onMounted, defineAsyncComponent } from "vue";
import { toast } from "vue3-toastify";
import apiService from "@/services/apiService";
import { usePermissions } from "@/composables/usePermissions";


export default /*@__PURE__*/_defineComponent({
  __name: 'FreeSubscriptions',
  setup(__props) {

const { canView, canUpdate, canCreate } = usePermissions();

// Lazy load modal components
const SubscriptionModal = defineAsyncComponent(
  () => import("@/components/theme/admin/subscriptions/SubscriptionModal.vue")
);
const SubscriptionViewModal = defineAsyncComponent(
  () =>
    import("@/components/theme/admin/subscriptions/SubscriptionViewModal.vue")
);

// Toast functionality is imported above

// Reactive data
const subscriptions = ref<any[]>([]);
const packages = ref<any[]>([]);
const currencies = ref<any[]>([]);
const loading = ref(false);
const totalItems = ref(0);
const currentPage = ref(1);
const itemsPerPage = ref(10);

// Search and filters
const searchQuery = ref("");  
const filterUserId = ref("");
const sortBy = ref("createdAt");

// Modal states
const showModal = ref(false);
const showViewModal = ref(false);
const selectedSubscription = ref<any>(null);
const isEditMode = ref(false);

// Debounced search
let searchTimeout: any;

// Computed
const totalPages = computed(() =>
  Math.ceil(totalItems.value / itemsPerPage.value)
);

const startItem = computed(
  () => (currentPage.value - 1) * itemsPerPage.value + 1
);

const endItem = computed(() =>
  Math.min(currentPage.value * itemsPerPage.value, totalItems.value)
);

const visiblePages = computed(() => {
  const total = totalPages.value;
  const current = currentPage.value;
  const delta = 2;

  const range = [];
  const rangeWithDots = [];

  for (
    let i = Math.max(2, current - delta);
    i <= Math.min(total - 1, current + delta);
    i++
  ) {
    range.push(i);
  }

  if (current - delta > 2) {
    rangeWithDots.push(1, "...");
  } else {
    rangeWithDots.push(1);
  }

  rangeWithDots.push(...range);

  if (current + delta < total - 1) {
    rangeWithDots.push("...", total);
  } else if (total > 1) {
    rangeWithDots.push(total);
  }

  return rangeWithDots.filter(
    (item, index, array) => array.indexOf(item) === index
  );
});
const fetchPackages = async () => {
  try {
    const response = await apiService.getPackages({ limit: 100 });
    if (response?.packages) {
      packages.value = response.packages;
    } else if (response?.data?.packages) {
      packages.value = response.data.packages;
    } else {
      packages.value = [];
    }
  } catch (error) {
    console.error("Error fetching packages:", error);
  }
};

// Methods
const fetchSubscriptions = async () => {
  try {
    loading.value = true; 
    const params: any = {
      page: currentPage.value,
      limit: itemsPerPage.value,
      type: 'free'
    };


    if (searchQuery.value) {
      params.search = searchQuery.value;
    } 

    if (filterUserId.value) {
      params.userId = filterUserId.value;
    }

    const response = await apiService.getSubscriptions(params);

    // Handle the response structure
    if (response?.subscriptions) {
      subscriptions.value = response.subscriptions;
      totalItems.value =
        response.pagination?.totalItems || response.subscriptions.length;
    } else if (response?.data?.subscriptions) {
      subscriptions.value = response.data.subscriptions;
      totalItems.value =
        response.data.pagination?.totalItems ||
        response.data.subscriptions.length;
    } else if (Array.isArray(response)) {
      subscriptions.value = response;
      totalItems.value = response.length;
    } else {
      subscriptions.value = [];
      totalItems.value = 0;
    }
  } catch (error) {
    console.error("Error fetching subscriptions:", error);
    toast.error("Failed to load subscriptions");
    subscriptions.value = [];
  } finally {
    loading.value = false;
  }
};



const fetchCurrencies = async () => {
  try {
    const response = await apiService.getCurrencies({ limit: 100 });
    if (response.data && response.data.currencies) {
      currencies.value = response.data.currencies;
    } else if (response.currencies) {
      currencies.value = response.currencies;
    } else {
      currencies.value = response || [];
    }
  } catch (error) {
    console.error("Error fetching currencies:", error);
  }
};

const handleSearch = () => {
  clearTimeout(searchTimeout);
  searchTimeout = setTimeout(() => {
    currentPage.value = 1;
    fetchSubscriptions();
  }, 500);
};

const handleFilter = () => {
  currentPage.value = 1;
  fetchSubscriptions();
};

const resetFilters = () => {
  searchQuery.value = ""; 
  filterUserId.value = "";
  sortBy.value = "createdAt";
  currentPage.value = 1;
  fetchSubscriptions();
};

const changePage = (page: number) => {
  if (page >= 1 && page <= totalPages.value) {
    currentPage.value = page;
    fetchSubscriptions();
  }
};

// Modal methods
const openCreateModal = () => {
  selectedSubscription.value = null;
  isEditMode.value = false;
  showModal.value = true;
};

const editSubscription = (subscription: any) => {
  selectedSubscription.value = { ...subscription };
  isEditMode.value = true;
  showModal.value = true;
};

const viewSubscription = (subscription: any) => {
  selectedSubscription.value = subscription;
  showViewModal.value = true;
};

const closeModal = () => {
  showModal.value = false;
  selectedSubscription.value = null;
  isEditMode.value = false;
};

const closeViewModal = () => {
  showViewModal.value = false;
  selectedSubscription.value = null;
};

const handleEditFromView = (subscription: any) => {
  closeViewModal();
  editSubscription(subscription);
};

const handleSubscriptionSaved = () => {
  closeModal();
  fetchSubscriptions();
  toast.success(
    isEditMode.value
      ? "Subscription updated successfully"
      : "Subscription created successfully"
  );
};

// Subscription actions
const pauseSubscription = async (id: string) => {
  if (!confirm("Are you sure you want to pause this subscription?")) return;

  try {
    await apiService.pauseSubscription(id);
    toast.success("Subscription paused successfully");
    fetchSubscriptions();
  } catch (error) {
    console.error("Error pausing subscription:", error);
    toast.error("Failed to pause subscription");
  }
};

const resumeSubscription = async (id: string) => {
  if (!confirm("Are you sure you want to resume this subscription?")) return;

  try {
    await apiService.resumeSubscription(id);
    toast.success("Subscription resumed successfully");
    fetchSubscriptions();
  } catch (error) {
    console.error("Error resuming subscription:", error);
    toast.error("Failed to resume subscription");
  }
};

const cancelSubscription = async (id: string) => {
  if (
    !confirm(
      "Are you sure you want to cancel this subscription? This action cannot be undone."
    )
  )
    return;

  try {
    await apiService.cancelSubscription(id);
    toast.success("Subscription canceled successfully");
    fetchSubscriptions();
  } catch (error) {
    console.error("Error canceling subscription:", error);
    toast.error("Failed to cancel subscription");
  }
};

// Utility methods
const getUserDisplay = (userId: any): string => {
  if (typeof userId === "object" && userId !== null) {
    return userId.name || userId.email || userId._id || "Unknown User";
  }
  return userId || "Unknown User";
};

const getPackageName = (packageData: any): string => {
  if (typeof packageData === "object" && packageData !== null) {
    return packageData.name || "Unknown Package";
  } else if (typeof packageData === "string") {
    const foundPackage = packages.value.find((p) => p._id === packageData);
    return foundPackage?.name || "Unknown Package";
  }
  return "Unknown Package";
};

const getStatusBadgeClass = (status: string): string => {
  const statusClasses: Record<string, string> = {
    active: "bg-success text-white",
    trialing: "bg-info text-white",
    past_due: "bg-warning text-dark",
    canceled: "bg-danger text-white",
    unpaid: "bg-secondary text-white",
    paused: "bg-dark text-white",
  };
  return statusClasses[status] || "bg-secondary text-white";
};

const formatStatus = (status: string): string => {
  const statusLabels: Record<string, string> = {
    active: "Active",
    trialing: "Trialing",
    past_due: "Past Due",
    canceled: "Canceled",
    unpaid: "Unpaid",
    paused: "Paused",
  };
  return statusLabels[status] || status;
};

const formatInterval = (interval: string): string => {
  const intervals: Record<string, string> = {
    day: "Daily",
    week: "Weekly",
    month: "Monthly",
    year: "Yearly",
  };
  return intervals[interval] || interval;
};

const formatAmount = (amount: number, currency: any): string => {
  const currencyCode = typeof currency === "object" ? currency.code : currency;
  const currencySymbol = typeof currency === "object" ? currency.symbol : "$";
  return `${currencySymbol}${(amount / 100).toFixed(2)}`;
};

const formatDate = (date: string): string => {
  if (!date) return "N/A";
  return new Date(date).toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
};

onMounted(async () => {
  await Promise.all([fetchPackages(), fetchCurrencies(), fetchSubscriptions()]);
});

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Breadcrumbs, { title: "Subscriptions" }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _cache[6] || (_cache[6] = _createElementVNode("h4", { class: "mb-0" }, [
                  _createElementVNode("i", { class: "fas fa-credit-card me-2" }),
                  _createTextVNode(" Subscription Management ")
                ], -1)),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("button", {
                    class: "btn btn-primary",
                    onClick: openCreateModal,
                    disabled: !_unref(canCreate)('subscriptions')
                  }, [...(_cache[5] || (_cache[5] = [
                    _createElementVNode("i", { class: "fas fa-plus me-1" }, null, -1),
                    _createTextVNode(" Add Subscription ", -1)
                  ]))], 8, _hoisted_8)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _cache[7] || (_cache[7] = _createElementVNode("span", { class: "input-group-text" }, [
                      _createElementVNode("i", { class: "fas fa-search" })
                    ], -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchQuery).value = $event)),
                      type: "text",
                      class: "form-control",
                      placeholder: "Search subscriptions...",
                      onInput: handleSearch
                    }, null, 544), [
                      [_vModelText, searchQuery.value]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _withDirectives(_createElementVNode("input", {
                      width: "200px",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filterUserId).value = $event)),
                      type: "text",
                      class: "form-control",
                      placeholder: "Filter by User ID",
                      onInput: handleFilter
                    }, null, 544), [
                      [_vModelText, filterUserId.value]
                    ]),
                    _withDirectives(_createElementVNode("select", {
                      style: {"width":"150px"},
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((sortBy).value = $event)),
                      class: "form-select",
                      onChange: handleFilter
                    }, [...(_cache[8] || (_cache[8] = [
                      _createElementVNode("option", { value: "createdAt" }, "Created Date", -1),
                      _createElementVNode("option", { value: "updatedAt" }, "Updated Date", -1),
                      _createElementVNode("option", { value: "status" }, "Status", -1),
                      _createElementVNode("option", { value: "userId" }, "User ID", -1)
                    ]))], 544), [
                      [_vModelSelect, sortBy.value]
                    ])
                  ])
                ])
              ]),
              (loading.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [...(_cache[9] || (_cache[9] = [
                    _createElementVNode("div", {
                      class: "spinner-border text-primary",
                      role: "status"
                    }, [
                      _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
                    ], -1)
                  ]))]))
                : (subscriptions.value.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _createElementVNode("table", _hoisted_17, [
                        _cache[19] || (_cache[19] = _createElementVNode("thead", { class: "table-dark" }, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("th", {
                              scope: "col",
                              style: {"width":"80px"}
                            }, "Sr No"),
                            _createElementVNode("th", {
                              scope: "col",
                              style: {"min-width":"120px"}
                            }, "User ID"),
                            _createElementVNode("th", {
                              scope: "col",
                              style: {"min-width":"150px"}
                            }, "Package"),
                            _createElementVNode("th", {
                              scope: "col",
                              style: {"width":"100px"}
                            }, "Status"),
                            _createElementVNode("th", {
                              scope: "col",
                              style: {"width":"100px"}
                            }, "Interval"),
                            _createElementVNode("th", {
                              scope: "col",
                              style: {"width":"120px"}
                            }, "Price"),
                            _createElementVNode("th", {
                              scope: "col",
                              style: {"width":"160px"}
                            }, "Trial Days"),
                            _createElementVNode("th", {
                              scope: "col",
                              style: {"width":"120px"}
                            }, "Created"),
                            _createElementVNode("th", {
                              scope: "col",
                              style: {"width":"200px"}
                            }, "Actions")
                          ])
                        ], -1)),
                        _createElementVNode("tbody", _hoisted_18, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subscriptions.value, (subscription, index) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: subscription._id
                            }, [
                              _createElementVNode("td", _hoisted_19, [
                                _createElementVNode("span", _hoisted_20, _toDisplayString((currentPage.value - 1) * itemsPerPage.value + index + 1), 1)
                              ]),
                              _createElementVNode("td", null, [
                                _createElementVNode("div", null, [
                                  _createElementVNode("strong", null, _toDisplayString(getUserDisplay(subscription.userId)), 1)
                                ])
                              ]),
                              _createElementVNode("td", null, [
                                _createElementVNode("div", null, [
                                  _createElementVNode("strong", null, _toDisplayString(getPackageName(subscription.packageId)), 1),
                                  (subscription.workspaceId)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, " Workspace: " + _toDisplayString(subscription.workspaceId), 1))
                                    : _createCommentVNode("", true)
                                ])
                              ]),
                              _createElementVNode("td", null, [
                                _createElementVNode("span", {
                                  class: _normalizeClass([getStatusBadgeClass(subscription.status), "badge"])
                                }, _toDisplayString(formatStatus(subscription.status)), 3)
                              ]),
                              _createElementVNode("td", null, [
                                _createElementVNode("span", _hoisted_22, _toDisplayString(formatInterval(subscription.interval)), 1)
                              ]),
                              _createElementVNode("td", null, [
                                (subscription.customPrice)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                      _createElementVNode("strong", null, _toDisplayString(formatAmount(
                              subscription.customPrice.amount,
                              subscription.customPrice.currency
                            )), 1),
                                      _cache[10] || (_cache[10] = _createElementVNode("div", { class: "text-muted small" }, "Custom", -1))
                                    ]))
                                  : (subscription.packagePrice)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                        _createElementVNode("strong", null, _toDisplayString(formatAmount(
                              subscription.packagePrice.amount,
                              subscription.packagePrice.currency
                            )), 1),
                                        _cache[11] || (_cache[11] = _createElementVNode("div", { class: "text-muted small" }, "Package", -1))
                                      ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_25, [...(_cache[12] || (_cache[12] = [
                                        _createElementVNode("span", { class: "text-muted" }, "N/A", -1)
                                      ]))]))
                              ]),
                              _createElementVNode("td", _hoisted_26, [
                                (subscription.trialDays)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(subscription.trialDays) + " days ", 1))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_28, "-"))
                              ]),
                              _createElementVNode("td", null, [
                                _createElementVNode("span", _hoisted_29, _toDisplayString(formatDate(subscription.createdAt)), 1)
                              ]),
                              _createElementVNode("td", null, [
                                _createElementVNode("div", _hoisted_30, [
                                  _createElementVNode("button", {
                                    class: "btn btn-sm btn-outline-info",
                                    onClick: ($event: any) => (viewSubscription(subscription)),
                                    title: "View Details",
                                    disabled: !_unref(canView)('subscriptions')
                                  }, [...(_cache[13] || (_cache[13] = [
                                    _createElementVNode("i", { class: "fas fa-eye" }, null, -1)
                                  ]))], 8, _hoisted_31),
                                  _createElementVNode("button", {
                                    class: "btn btn-sm btn-outline-primary",
                                    onClick: ($event: any) => (editSubscription(subscription)),
                                    title: "Edit",
                                    disabled: !_unref(canUpdate)('subscriptions')
                                  }, [...(_cache[14] || (_cache[14] = [
                                    _createElementVNode("i", { class: "fas fa-edit" }, null, -1)
                                  ]))], 8, _hoisted_32),
                                  _createElementVNode("div", _hoisted_33, [
                                    _createElementVNode("button", {
                                      class: "btn btn-sm text-center border btn-outline-secondary dropdown-toggle",
                                      type: "button",
                                      id: `dropdown-${subscription._id}`,
                                      "data-bs-toggle": "dropdown",
                                      "aria-expanded": "false",
                                      title: "More Actions",
                                      disabled: !_unref(canUpdate)('subscriptions')
                                    }, [...(_cache[15] || (_cache[15] = [
                                      _createElementVNode("i", { class: "fas fa-ellipsis-h" }, null, -1)
                                    ]))], 8, _hoisted_34),
                                    _createElementVNode("ul", {
                                      class: "dropdown-menu",
                                      "aria-labelledby": `dropdown-${subscription._id}`
                                    }, [
                                      (subscription.status === 'active')
                                        ? (_openBlock(), _createElementBlock("li", _hoisted_36, [
                                            _createElementVNode("a", {
                                              class: "dropdown-item",
                                              href: "#",
                                              onClick: _withModifiers(($event: any) => (
                                    pauseSubscription(subscription._id)
                                  ), ["prevent"])
                                            }, [...(_cache[16] || (_cache[16] = [
                                              _createElementVNode("i", { class: "fas fa-pause me-2" }, null, -1),
                                              _createTextVNode("Pause ", -1)
                                            ]))], 8, _hoisted_37)
                                          ]))
                                        : _createCommentVNode("", true),
                                      (subscription.status === 'paused')
                                        ? (_openBlock(), _createElementBlock("li", _hoisted_38, [
                                            _createElementVNode("a", {
                                              class: "dropdown-item",
                                              href: "#",
                                              onClick: _withModifiers(($event: any) => (
                                    resumeSubscription(subscription._id)
                                  ), ["prevent"])
                                            }, [...(_cache[17] || (_cache[17] = [
                                              _createElementVNode("i", { class: "fas fa-play me-2" }, null, -1),
                                              _createTextVNode("Resume ", -1)
                                            ]))], 8, _hoisted_39)
                                          ]))
                                        : _createCommentVNode("", true),
                                      (
                                  ['active', 'trialing', 'past_due'].includes(
                                    subscription.status
                                  )
                                )
                                        ? (_openBlock(), _createElementBlock("li", _hoisted_40, [
                                            _createElementVNode("a", {
                                              class: "dropdown-item text-danger",
                                              href: "#",
                                              onClick: _withModifiers(($event: any) => (
                                    cancelSubscription(subscription._id)
                                  ), ["prevent"])
                                            }, [...(_cache[18] || (_cache[18] = [
                                              _createElementVNode("i", { class: "fas fa-times me-2" }, null, -1),
                                              _createTextVNode("Cancel ", -1)
                                            ]))], 8, _hoisted_41)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ], 8, _hoisted_35)
                                  ])
                                ])
                              ])
                            ]))
                          }), 128))
                        ])
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_42, [
                      _cache[21] || (_cache[21] = _createElementVNode("i", { class: "fas fa-credit-card fa-3x text-muted mb-3" }, null, -1)),
                      _cache[22] || (_cache[22] = _createElementVNode("h5", { class: "text-muted" }, "No subscriptions found", -1)),
                      _cache[23] || (_cache[23] = _createElementVNode("p", { class: "text-muted" }, " Create your first subscription to get started. ", -1)),
                      _createElementVNode("button", {
                        class: "btn btn-primary",
                        onClick: openCreateModal
                      }, [...(_cache[20] || (_cache[20] = [
                        _createElementVNode("i", { class: "fas fa-plus me-1" }, null, -1),
                        _createTextVNode(" Add Subscription ", -1)
                      ]))])
                    ])),
              (totalPages.value > 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                    _createElementVNode("div", _hoisted_44, " Showing " + _toDisplayString(startItem.value) + " to " + _toDisplayString(endItem.value) + " of " + _toDisplayString(totalItems.value) + " subscriptions ", 1),
                    _createElementVNode("nav", _hoisted_45, [
                      _createElementVNode("ul", _hoisted_46, [
                        _createElementVNode("li", {
                          class: _normalizeClass(["page-item", { disabled: currentPage.value === 1 }])
                        }, [
                          _createElementVNode("a", {
                            class: "page-link",
                            href: "#",
                            onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (changePage(currentPage.value - 1)), ["prevent"])),
                            "aria-label": "Previous"
                          }, [...(_cache[24] || (_cache[24] = [
                            _createElementVNode("span", { "aria-hidden": "true" }, "«", -1)
                          ]))])
                        ], 2),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visiblePages.value, (page) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: page,
                            class: _normalizeClass(["page-item", { active: page === currentPage.value }])
                          }, [
                            _createElementVNode("a", {
                              class: _normalizeClass(["page-link", {'text-white': page === currentPage.value }]),
                              href: "#",
                              onClick: _withModifiers(($event: any) => (typeof page === 'number' && changePage(page)), ["prevent"])
                            }, _toDisplayString(page), 11, _hoisted_47)
                          ], 2))
                        }), 128)),
                        _createElementVNode("li", {
                          class: _normalizeClass(["page-item", { disabled: currentPage.value === totalPages.value }])
                        }, [
                          _createElementVNode("a", {
                            class: "page-link",
                            href: "#",
                            onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (changePage(currentPage.value + 1)), ["prevent"])),
                            "aria-label": "Next"
                          }, [...(_cache[25] || (_cache[25] = [
                            _createElementVNode("span", { "aria-hidden": "true" }, "»", -1)
                          ]))])
                        ], 2)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ]),
    (showModal.value)
      ? (_openBlock(), _createBlock(_unref(SubscriptionModal), {
          key: 0,
          show: showModal.value,
          subscription: selectedSubscription.value,
          "is-edit": isEditMode.value,
          packages: packages.value,
          currencies: currencies.value,
          onClose: closeModal,
          onSaved: handleSubscriptionSaved
        }, null, 8, ["show", "subscription", "is-edit", "packages", "currencies"]))
      : _createCommentVNode("", true),
    (showViewModal.value)
      ? (_openBlock(), _createBlock(_unref(SubscriptionViewModal), {
          key: 1,
          show: showViewModal.value,
          subscriptionData: selectedSubscription.value,
          packages: packages.value,
          currencies: currencies.value,
          onClose: closeViewModal,
          onEdit: handleEditFromView
        }, null, 8, ["show", "subscriptionData", "packages", "currencies"]))
      : _createCommentVNode("", true)
  ]))
}
}

})